/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const listNotificationRecipientOptionsParamsQueryMax = 100;

export const listNotificationRecipientOptionsParamsLimitOneRegExp = new RegExp(
  '^(?:0*(?:[1-9][0-9]?|100))$',
);
export const listNotificationRecipientOptionsParamsLimitTwoMax = 100;

export const listNotificationRecipientOptionsParamsLimitDefault = 50;
export const listNotificationRecipientOptionsParamsCursorMax = 2000;

export const listNotificationRecipientOptionsParamsPolicyTeamIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);

export const ListNotificationRecipientOptionsParams = zod.object({
  query: zod.string().max(listNotificationRecipientOptionsParamsQueryMax).optional(),
  limit: zod
    .union([
      zod.string().regex(listNotificationRecipientOptionsParamsLimitOneRegExp),
      zod.int().min(1).max(listNotificationRecipientOptionsParamsLimitTwoMax),
    ])
    .default(listNotificationRecipientOptionsParamsLimitDefault),
  cursor: zod.string().min(1).max(listNotificationRecipientOptionsParamsCursorMax).optional(),
  policyTeamId: zod.uuid().regex(listNotificationRecipientOptionsParamsPolicyTeamIdRegExp),
});

export type ListNotificationRecipientOptionsParams = zod.input<
  typeof ListNotificationRecipientOptionsParams
>;
export type ListNotificationRecipientOptionsParamsOutput = zod.output<
  typeof ListNotificationRecipientOptionsParams
>;
